
import Vue from "vue";
import { Browse } from "@/models/browse";
import { ViewSidebarBlock } from "@/utils/views/view-sidebar";
import { ViewColumn } from "@/utils/views/view-column";
import { getSidebarBlockName } from "@/utils/views/sidebar-blocks";
import AppSidebarFieldEdit from "./SidebarFieldEdit.vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			editingField: null as ViewColumn | null,
			editingFieldIndex: -1
		};
	},
	props: {
		block: {
			type: Object as () => ViewSidebarBlock,
			required: true
		},
		browse: {
			type: Object as () => Browse
		},
		add: Boolean
	},
	computed: {
		columnItems():ISelectItem<number>[] {
			return [
				{text: this.$ct("sidebar.block-columns-1").toString(), value: 1},
				{text: this.$ct("sidebar.block-columns-2").toString(), value: 2}
			];
		},
		defaultTitle():string {
			if (this.block.isFieldsBlock) return this.$ct("sidebar.fields-block").toString();
			return getSidebarBlockName(this.block.Type);
		}
	},
	methods: {
		getFieldFriendlyName(field:ViewColumn):string {
			if (!this.browse) return "";
			let namedProp = this.browse.type.getField(field.Property);
			if (!namedProp) return "ERROR";
			return namedProp.getPropertyTranslation();
		},
		addField(){
			this.editingField = new ViewColumn();
			this.editingFieldIndex = -1;
		},
		editField(field:ViewColumn, index:number){
			this.editingField = new ViewColumn(field);
			this.editingFieldIndex = index;
		},
		saveField(){
			if (!this.editingField) return;
			if (this.editingFieldIndex == -1) {
				this.block.Fields.push(this.editingField);
			} else {
				this.block.Fields.splice(this.editingFieldIndex, 1, this.editingField);
			}
			this.editingField = null;
			this.editingFieldIndex = -1;
		},
		removeField(index:number){
			this.block.Fields.splice(index, 1);
		}
	},
	components: {
		AppSidebarFieldEdit
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
